/* ------------------------------------------------------------------
   ol-b2b-configurateur.js — Configurateur budget V3 (refonte 2026-06-02).
   - Type sejour (3 cards) determine les Services inclus
   - Cumul minimum de maisons selon nombre de personnes
   - Restauration : prix /personne /nuit
   - Services supplementaires : non inclus dans l'estimatif (devis sur mesure)
   - Lecture ?type= au load pour preselection depuis les cards 'Estimer le budget'
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  const sections = document.querySelectorAll('.ol-b2b-configurateur');
  if (!sections.length) return;

  function readType() {
    try {
      const params = new URLSearchParams(window.location.search);
      const t = params.get('type');
      if (t === 'seminaire' || t === 'team-building' || t === 'comite-executif') return t;
    } catch (e) {}
    return 'seminaire';
  }

  function formatPrice(amount, currency) {
    const rounded = Math.round(amount);
    return rounded.toLocaleString('fr-FR') + ' ' + currency;
  }

  // Algo : trouve la combinaison de maisons (chacune 0 ou 1 fois) qui couvre n personnes
  // avec en priorité (1) le moins de maisons, (2) le prix le plus bas.
  function findHouseCombo(nPeople, houses) {
    const N = houses.length;
    let best = null;
    for (let mask = 1; mask < (1 << N); mask++) {
      let cap = 0, price = 0, size = 0, subset = [];
      for (let i = 0; i < N; i++) {
        if (mask & (1 << i)) {
          cap += houses[i].capacity;
          price += houses[i].price;
          size += 1;
          subset.push(houses[i]);
        }
      }
      if (cap >= nPeople) {
        if (
          !best ||
          size < best.size ||
          (size === best.size && price < best.price)
        ) {
          best = { mask, cap, price, size, subset };
        }
      }
    }
    return best;
  }

  function initSection(section) {
    const ds = section.dataset;
    const currency = ds.configCurrency || '€';

    function intOr(v, fallback) {
      const n = parseInt(v, 10);
      return isNaN(n) || n <= 0 ? fallback : n;
    }

    const houses = [
      { id: 1, label: ds.configMaison1Label || 'Maison 1 (jusqu’à 4 personnes)', capacity: intOr(ds.configMaison1Capacity, 4), price: intOr(ds.configMaison1Price, 500) },
      { id: 2, label: ds.configMaison2Label || 'Maison 2 (jusqu’à 10 personnes)', capacity: intOr(ds.configMaison2Capacity, 10), price: intOr(ds.configMaison2Price, 1000) },
      { id: 3, label: ds.configMaison3Label || 'Maison 3 (jusqu’à 14 personnes)', capacity: intOr(ds.configMaison3Capacity, 14), price: intOr(ds.configMaison3Price, 1500) },
    ];

    const mealPrices = {
      sans: parseInt(ds.configMealSans, 10) || 0,
      pdj: intOr(ds.configMealPdj, 15),
      demi: intOr(ds.configMealDemi, 50),
      pension: intOr(ds.configMealPension, 100),
    };

    // State
    const state = {
      type: readType(),
      people: intOr(ds.configDefaultPeople, 10),
      nights: intOr(ds.configDefaultNights, 1),
      meal: 'sans',
    };

    // DOM refs
    const typesGroup = section.querySelector('.ol-b2b-configurateur__types');
    const typeButtons = section.querySelectorAll('[data-config-type]');
    const peopleSlider = section.querySelector('#config-participants');
    const nightsSlider = section.querySelector('#config-nuits');
    const mealButtons = section.querySelectorAll('[data-config-meal]');
    const inclusList = section.querySelector('[data-config-inclus]');
    const extraToggles = section.querySelectorAll('[data-config-toggle]');

    const peopleValue = section.querySelector('[data-config-value="participants"]');
    const nightsValue = section.querySelector('[data-config-value="nuits"]');
    const outTotal = section.querySelector('[data-config-output="total"]');
    const outPerPersonNight = section.querySelector('[data-config-output="per-person-night"]');
    const outHebergementTotal = section.querySelector('[data-config-output="hebergement-total"]');
    const outMaisonsList = section.querySelector('[data-config-maisons-list]');
    const outRestauration = section.querySelector('[data-config-output="restauration"]');
    const outTotalSejour = section.querySelector('[data-config-output="total-sejour"]');
    const ctaLink = section.querySelector('.ol-b2b-configurateur__cta');

    function getIncludedServices(type) {
      const raw = typesGroup.dataset['type' + capitalize(type) + 'Inclus'] || '';
      return raw.split('|').map(s => s.trim()).filter(Boolean).slice(0, 5);
    }

    function capitalize(slug) {
      return slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join('');
    }

    function renderTypeUI() {
      typeButtons.forEach(btn => {
        const active = btn.dataset.configType === state.type;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
      });
    }

    function renderInclus() {
      const services = getIncludedServices(state.type);
      inclusList.innerHTML = '';
      services.forEach(label => {
        const li = document.createElement('li');
        li.className = 'ol-b2b-configurateur__inclus-item';
        li.textContent = label;
        inclusList.appendChild(li);
      });
    }

    function renderExtrasVisibility() {
      extraToggles.forEach(btn => {
        const hideFor = (btn.dataset.configHideFor || '').split(',').map(s => s.trim()).filter(Boolean);
        const hidden = hideFor.indexOf(state.type) !== -1;
        btn.style.display = hidden ? 'none' : '';
        if (hidden) btn.setAttribute('aria-pressed', 'false');
      });
    }

    function renderMealUI() {
      mealButtons.forEach(btn => {
        const active = btn.dataset.configMeal === state.meal;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
      });
    }

    function renderSliders() {
      peopleValue.textContent = state.people + (state.people > 1 ? ' personnes' : ' personne');
      nightsValue.textContent = state.nights + (state.nights > 1 ? ' nuits' : ' nuit');
    }

    function recalcOutput() {
      const combo = findHouseCombo(state.people, houses);
      if (!combo) {
        outTotal.textContent = '—';
        outPerPersonNight.textContent = 'Capacité dépassée';
        outHebergementTotal.textContent = '—';
        outMaisonsList.innerHTML = '';
        outRestauration.textContent = '—';
        outTotalSejour.textContent = '—';
        return;
      }
      const housesPriceNight = combo.price;
      const mealPerPerson = mealPrices[state.meal] || 0;
      const restaurationPerNight = mealPerPerson * state.people;
      const totalPerNight = housesPriceNight + restaurationPerNight;
      const totalSejour = totalPerNight * state.nights;
      const perPersonPerNight = totalPerNight / state.people;

      outTotal.textContent = formatPrice(perPersonPerNight, currency);
      outPerPersonNight.textContent = 'par personne / par nuit · HT';

      outHebergementTotal.textContent = formatPrice(housesPriceNight * state.nights, currency);

      outMaisonsList.innerHTML = '';
      combo.subset.forEach(h => {
        const li = document.createElement('li');
        li.className = 'ol-b2b-configurateur__breakdown-maison';
        li.textContent = h.label;
        outMaisonsList.appendChild(li);
      });

      outRestauration.textContent = formatPrice(restaurationPerNight * state.nights, currency);
      outTotalSejour.textContent = formatPrice(totalSejour, currency);
    }

    function renderAll() {
      renderTypeUI();
      renderInclus();
      renderExtrasVisibility();
      renderMealUI();
      renderSliders();
      recalcOutput();
    }

    // Event listeners
    typeButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        state.type = btn.dataset.configType;
        renderTypeUI();
        renderInclus();
        renderExtrasVisibility();
      });
    });

    mealButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        state.meal = btn.dataset.configMeal;
        renderMealUI();
        recalcOutput();
      });
    });

    peopleSlider.addEventListener('input', () => {
      state.people = parseInt(peopleSlider.value, 10);
      renderSliders();
      recalcOutput();
    });

    nightsSlider.addEventListener('input', () => {
      state.nights = parseInt(nightsSlider.value, 10);
      renderSliders();
      recalcOutput();
    });

    extraToggles.forEach(btn => {
      btn.addEventListener('click', () => {
        const pressed = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
        btn.classList.toggle('is-active', !pressed);
      });
    });

    // Au clic CTA : preserver le contexte configurateur en querystring
    if (ctaLink) {
      const baseHref = ctaLink.getAttribute('href') || '#form-devis';
      ctaLink.addEventListener('click', () => {
        const params = new URLSearchParams();
        params.set('type', state.type);
        params.set('personnes', String(state.people));
        params.set('nuits', String(state.nights));
        params.set('formule', state.meal);
        const activeExtras = Array.from(extraToggles)
          .filter(b => b.getAttribute('aria-pressed') === 'true' && b.style.display !== 'none')
          .map(b => (b.textContent || '').trim())
          .filter(Boolean);
        if (activeExtras.length) params.set('services', activeExtras.join(','));
        const sep = baseHref.indexOf('#') === 0 ? '' : (baseHref.indexOf('?') === -1 ? '?' : '&');
        const anchor = baseHref.indexOf('#') === 0 ? baseHref : '';
        if (anchor) {
          ctaLink.setAttribute('href', '?' + params.toString() + anchor);
        } else {
          ctaLink.setAttribute('href', baseHref + sep + params.toString());
        }
      });
    }

    renderAll();
  }

  sections.forEach(initSection);
})();
